export const BELGIAN_ENTERPRISE_NUMBER = /^[0-9]{10}$/
export const LETTERS_NUMBERS_SLASHES_AND_DASHES = /^[a-zA-Z0-9/-]*$/
export const NO_NUMBERS = /^([^0-9]*)$/
export const POSTAL_CODE = /^[1-9][0-9]{3}$/
export const ZeroOrPositiveNumbersWithNoDecimals = /^[0-9]\d*$/
export const POSITIVE_WHOLE_NUMBERS = /^0*[1-9]\d*$/
